import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      minHeight: theme.spacing(4.5),
    },
    heading: {
      fontFamily: theme.typography.fontFamily ?? 'sans-serif',
      fontSize: '1.1rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    actions: {
      display: 'flex',
      gap: theme.spacing(1),
    },
  };
};
